import React, { useEffect, useState } from "react";
import { PrinterIcon } from "@heroicons/react/24/outline";
import { apiFetch } from "../api/client";

export default function PurchaseOrderDrafts() {
  const [drafts, setDrafts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(true);

  const loadDrafts = async () => {
    setLoading(true);
    try {
      const res = await apiFetch("/api/ai/purchase-order-drafts");
      if (res.status === 403) {
        setAllowed(false);
        return;
      }
      if (!res.ok) return;
      const body = await res.json();
      setDrafts(body?.data || body || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadDrafts(); }, []);

  const updateQuantity = (vendorIndex, itemIndex, quantity) => {
    setDrafts((current) => current.map((draft, index) => index !== vendorIndex ? draft : {
      ...draft,
      items: draft.items.map((item, itemPosition) => itemPosition !== itemIndex ? item : { ...item, suggestedReorderQuantity: Math.max(0, Number(quantity) || 0) })
    }));
  };

  if (!allowed) return <div className="col-span-12 lg:col-span-10 p-6"><div className="rounded-xl border border-[#D326AD]/30 bg-[#111B31] p-6 text-[#E6EEF3]"><h1 className="text-xl font-semibold">Premium feature</h1><p className="mt-2 text-[#C7D2FE]">Purchase Order Drafts are available on the Premium plan.</p></div></div>;

  return (
    <div className="col-span-12 lg:col-span-10 p-4 sm:p-6">
      <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div><h1 className="text-2xl font-bold text-[#E6EEF3]">Purchase Order Drafts</h1><p className="mt-1 text-sm text-[#C7D2FE]">Review and adjust AI reorder recommendations before sending them to vendors.</p></div>
        <button onClick={() => window.print()} className="inline-flex items-center justify-center gap-2 rounded-lg bg-[#8A17D1] px-4 py-2 text-sm font-semibold text-white hover:bg-[#D326AD]"><PrinterIcon className="h-4 w-4" />Print / Save PDF</button>
      </div>
      {loading ? <div className="flex min-h-64 items-center justify-center"><div className="h-10 w-10 animate-spin rounded-full border-4 border-[#C7D2FE]/30 border-t-[#8A17D1]" /></div> : drafts.length === 0 ? <div className="rounded-xl border border-[#C7D2FE]/15 bg-[#111B31] p-6 text-[#C7D2FE]">No purchase order drafts are needed right now.</div> : <div className="space-y-5">{drafts.map((draft, vendorIndex) => <section key={`${draft.vendorName}-${vendorIndex}`} className="rounded-xl border border-[#C7D2FE]/15 bg-[#111B31] p-5"><h2 className="text-lg font-semibold text-[#f3a1dc]">{draft.vendorName}</h2><div className="mt-4 overflow-x-auto"><table className="min-w-full text-left text-sm"><thead className="border-b border-[#C7D2FE]/15 text-[#C7D2FE]"><tr><th className="pb-3 pr-4">Product</th><th className="pb-3 pr-4">Current stock</th><th className="pb-3">Order quantity</th></tr></thead><tbody>{draft.items?.map((item, itemIndex) => <tr key={`${item.productId}-${itemIndex}`} className="border-b border-[#C7D2FE]/10 last:border-0"><td className="py-3 pr-4 text-[#E6EEF3]">{item.productName}</td><td className="py-3 pr-4 text-[#C7D2FE]">{item.currentStock}</td><td className="py-3"><input aria-label={`Order quantity for ${item.productName}`} type="number" min="0" value={item.suggestedReorderQuantity} onChange={(event) => updateQuantity(vendorIndex, itemIndex, event.target.value)} className="w-24 rounded-md border border-[#8A17D1]/50 bg-[#071026] px-2 py-1 text-[#E6EEF3]" /></td></tr>)}</tbody></table></div></section>)}</div>}
    </div>
  );
}
